/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FreeNightMatch } from './FreeNightMatch';
import {
    FreeNightMatchFromJSON,
    FreeNightMatchFromJSONTyped,
    FreeNightMatchToJSON,
    FreeNightMatchToJSONTyped,
} from './FreeNightMatch';

/**
 * One match per property that produced a non-null result. Properties with
 * no seeded award attributes, no applicable FNC, or no user FNCs are
 * omitted entirely — the FE treats absence as "no badge".
 * 
 * @export
 * @interface FreeNightMatchResponse
 */
export interface FreeNightMatchResponse {
    /**
     * 
     * @type {Array<FreeNightMatch>}
     * @memberof FreeNightMatchResponse
     */
    matches: Array<FreeNightMatch>;
}

/**
 * Check if a given object implements the FreeNightMatchResponse interface.
 */
export function instanceOfFreeNightMatchResponse(value: object): value is FreeNightMatchResponse {
    if (!('matches' in value) || value['matches'] === undefined) return false;
    return true;
}

export function FreeNightMatchResponseFromJSON(json: any): FreeNightMatchResponse {
    return FreeNightMatchResponseFromJSONTyped(json, false);
}

export function FreeNightMatchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreeNightMatchResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'matches': ((json['matches'] as Array<any>).map(FreeNightMatchFromJSON)),
    };
}

export function FreeNightMatchResponseToJSON(json: any): FreeNightMatchResponse {
    return FreeNightMatchResponseToJSONTyped(json, false);
}

export function FreeNightMatchResponseToJSONTyped(value?: FreeNightMatchResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'matches': ((value['matches'] as Array<any>).map(FreeNightMatchToJSON)),
    };
}

